/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

import React, { useState, useEffect } from 'react';
import { Divider, Typography, Grid, MenuItem, Container, Popover } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom';
import i18next from 'i18next';
import { BrowserView } from 'react-device-detect';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const PageHeader = ({ ...props }) => {
  const [language, setLanguage] = useState('en')
  const [navbar, setNavbar] = useState(false);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState('');
  const [openService, setOpenService] = useState(false);
  const [anchorElService, setAnchorElService] = useState('')
  const { t } = useTranslation()


  const handleChange = (name, event) => {
    i18next.changeLanguage(name).then(() => {
      switch (name) {
        case "en":
          setLanguage("en")
          localStorage.setItem("lang", "en")
          break;
        case "fr":
          setLanguage("fr")
          localStorage.setItem("lang", "fr")

          break;
        case "es":
          setLanguage("es")
          localStorage.setItem("lang", "es")

          break;
        default:
          setLanguage("en")
          localStorage.setItem("lang", "en")

          break;
      }
    });

    handleClose()
  };
  useEffect(() => {
    if (localStorage.getItem("lang")) {
      setLanguage(localStorage.getItem("lang"))
    }
    // adding the event when scroll change Logo
    window.addEventListener("scroll", changeBackground)
  }, [])
  const changeBackground = () => {
    if (window.scrollY >= 66) {
      setNavbar(true)
    } else {
      setNavbar(false)
    }
  }
  const handleClick = (event) => {
    setOpen(true)
    setAnchorEl(event.currentTarget)
  };
  const handleClickService = (event) => {
    setOpenService(true)
    setAnchorElService(event.currentTarget)
  };
  const handleClose = () => {
    setOpen(false)
    setOpenService(false)


  };
  const navigate = useNavigate()
  const { divider } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Grid container justify="space-between" alignItems="center" className={navbar ? "navbarActive" : "navbar"}>
        <Grid item className={classes.navBar}>
          <Container maxWidth="xl">

            <AppBar
              position="static"
              elevation={0}
              color="primary"
              className={classes.appBar}
            >
              <Toolbar className={classes.toolbar}>
                <a
                  href={"/home"}
                >
                  <img src="/assets/images/belltane/beltane_logo.png" height="50px" alt="" />
                </a>
                <BrowserView>
                  <Typography variant="h3" className={classes.toolbarTitle}>
                    Belltane
                  </Typography>
                </BrowserView>


                <nav style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                  <a
                    variant="button"
                    color="textPrimary"
                    href="/home"
                    className={classes.link}
                  >
                    {t('topbar:homePage')}
                  </a>


                  <Typography style={{ color: 'white' }} variant="h4" onClick={handleClickService}
                    className={classes.link}>{t('topbar:services')} <ArrowDropDownIcon style={{ verticalAlign: 'bottom' }} />
                  </Typography>
                  <Popover
                    id="simple-menu"
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    open={openService}
                    onClose={handleClose}
                    anchorEl={anchorElService}
                    style={{ maxWidth: '200px' }}
                  >
                    <MenuItem onClick={(e) => { navigate("/enterprise"); handleClose() }} style={{
                      width: '100%', maxWidth: '200px', height: '40px'
                    }} >

                      <Typography color="textPrimary" variant="h5">  {t('titles:enterprise')}</Typography>
                    </MenuItem>
                    <Divider />

                    <MenuItem onClick={(e) => { navigate("/digitalassets"); handleClose() }} style={{
                      width: '100%', maxWidth: '200px', height: '40px'
                    }} >

                      <Typography color="textPrimary" variant="h5">  {t('titles:digitalassets')}</Typography>
                    </MenuItem>
                    <Divider />

                    <MenuItem onClick={(e) => { navigate("/artificialintelligence"); handleClose() }} style={{
                      width: '100%', maxWidth: '200px', height: '40px'
                    }} >

                      <Typography color="textPrimary" variant="h5">  {t('titles:artificialintelligence')}</Typography>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={(e) => { navigate("/customsolutions"); handleClose() }} style={{
                      width: '100%', maxWidth: '200px', height: '40px'
                    }} >

                      <Typography color="textPrimary" variant="h5">  {t('titles:customsolutions')}</Typography>
                    </MenuItem>
                    <Divider />
                  </Popover>
                  <a href="/about" className={classes.link}>
                      {t('topbar:about')} 
                  </a>
                  <a href="/contact" className={classes.link}>
                   {t('topbar:contactus')} 
                  </a>
                </nav>
                <nav style={{ marginLeft: 'auto' }}>

                  <a href="/home/#faq" className={classes.link}>

                  {t('topbar:FAQ')} 
                  </a>
                  <Button aria-controls="simple-menu" alt="" style={{ maxWidth: '20px', marginLeft: 'auto' }}

                    aria-haspopup="true" onClick={handleClick}>
                    <Typography color="white">{language}</Typography>
                  </Button>
                  <Popover
                    id="simple-menu"
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    open={open}
                    onClose={handleClose}
                    anchorEl={anchorEl}
                    style={{ maxWidth: '170px' }}
                  >
                    <MenuItem onClick={(e) => handleChange('en', e)} style={{
                      width: '100%', maxWidth: '170px', height: '40px'
                    }} >

                      <Typography  color="textPrimary" variant="h5"> {t('topbar:en')}</Typography>
                    </MenuItem>
                    <Divider />

                    <MenuItem onClick={(e) => handleChange('es', e)} style={{ width: '100%', maxWidth: '170px', height: '40px' }} >

                      <Typography color="textPrimary" variant="h5"> {t('topbar:es')}</Typography></MenuItem>
                    <Divider />
                    <MenuItem onClick={(e) => handleChange('fr', e)} style={{ width: '100%', maxWidth: '170px', display: 'flex', height: '40px' }} >
                      <Typography color="textPrimary" variant="h5">   {t('topbar:fr')}</Typography>
                    </MenuItem>

                  </Popover>

                  <Button
                    component={Link}
                    to="/login"
                    variant="contained"
                    className={classes.link}
                    style={{ marginLeft: 'auto' }}
                  >
                    {t('topbar:login')}
                  </Button>
                </nav>
              </Toolbar>
            </AppBar>
          </Container>

        </Grid>
      </Grid>
      {divider && <Divider className={classes.divider} />}
    </div>
  );

}

const useStyles = makeStyles({ "name": { PageHeader } })((theme) => ({
  root: {
    width: '100%',
    position: 'fixed',
    zIndex: '111',
    minHeight: '80px!important'
  },
  navBar: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.divider}`,
    minHeight: '80px!important'


  },
  '@global': {
    ul: {
      margin: 0,
      padding: 0
    },
    li: {
      listStyle: 'none'
    }
  },
  appBar: {
    width: '100%',
    background: 'transparent!important'

  },

  toolbar: {
    flexWrap: 'wrap',
    minHeight: '80px!important'

  },
  toolbarTitle: {
    color: 'white',
    background: 'transparent'
  },
  link: {
    margin: theme.spacing(1, 1.5),
    color: "white!important",
    display: "inline-block",
    cursor: 'pointer',
    fontFamily: "'Roboto', sans-serif"


  },
  divider: {
    marginTop: theme.spacing(3)
  }
}));
export default PageHeader;